/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import OrderHistory from './order-history';
import OrderHistoryView from './order-history.view';

export * from './actions/get-order-shipment-history';
export * from './components';
export * from './order-history';
export * from './order-history.data';
export { IOrderHistoryConfig, IOrderHistoryProps, IOrderHistoryResources } from './order-history.props.autogenerated';
export * from './order-history.view';

export { OrderHistory, OrderHistoryView };
